<main class="container my-4" role="main" aria-label="Result Profile">
  <div class="div-main">
    <div class="search-params">
      <div class="paramtitle">
        {{ constants.RESULT_PROFILE.SEARCH_PARAMETER }}
      </div>
      <div class="param" *ngFor="let param of searchParams">
        <span class="paramname">{{ param.display }}:</span>
        {{ param.value }}
      </div>
    </div>
    <div class="search-criteria" *ngIf="selectedKey">
      <div class="div-select">
        <span>Select: </span>
        <select
          class="sel-cr"
          [(ngModel)]="selectedKey"
          (change)="changeCriteria()"
          aria-label="Select Bulk Search Criteria"
        >
          <option
            [value]="bs.key"
            *ngFor="let bs of commonService.bulkSearchResponse()"
          >
            {{ constants.RESULT_PROFILE.SELECT_CRITERIA }} {{ bs.key }}
          </option>
        </select>
      </div>
      <span
        class="inprogress"
        *ngIf="bulkSearchService.bulkSearchStatus() === 'InProgress'"
        role="status"
        aria-live="polite"
      >
        <span class="bulk-search-spinner"
          ><mat-spinner diameter="20"></mat-spinner
        ></span>
        <span>Bulk search is in progress...</span>
      </span>

      <button
        class="submit-btn bs-export"
        [disabled]="bulkSearchService.bulkSearchStatus() === 'InProgress'"
        aria-label="Export Bulk Search"
        (click)="BulkExport()"
      >
        <i class="bi bi-download icon fs-5 btn-icon"></i>
        {{ constants.RESULT_PROFILE.EXPORT_BULK_SEARCH }}
      </button>
    </div>
    

    <div class="card-wrap">
      <div class="btn-reset-cr">
         <button
          class="btn reset-btn"
          (click)="resetSearch()"
          aria-label="Go Back"
        >
          <i class="bi bi-arrow-left-circle icon fs-4 btn-icon"></i
          >{{ constants.RESULT_PROFILE.GO_BACK }}
        </button>
        <div class="src-filter">
          <label for="select_source" class="label-src">{{
            constants.RESULT_PROFILE.SELECT_SOURCES
          }}</label>
          <mat-form-field
            color="primary"
            appearance="outline"
            class="purple-select"
          >
            <!-- <mat-label class="lbl-src">Show/Hide Sources</mat-label> -->
            <mat-select
              [(ngModel)]="selectedSources"
              multiple
              (selectionChange)="toggleAllSelection()"
            >
              <mat-option *ngFor="let src of distinctSource" [value]="src">
                {{ src }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="btns-right">
          <button
            class="btn reset-btn"
            (click)="showColumnSetting('cross reference')"
          >
            <img src="assets/images/columnthing.svg" alt="column thing" class="btn-icon-svg" />
            {{ constants.RESULT_PROFILE.COLUMN_SETTINGS }}
          </button>
          <button
            class="btn reset-btn push-right"
            (click)="exportSourceCrossRefData()"
          >
            <div class="label-img">
              <i class="bi bi-download icon fs-5 btn-icon"></i>
              Export
            </div>
          </button>
             <button
            *ngIf="!hasExpPrefCol"
            matTooltip="No column preferences found to be export"
            class="btn reset-btn-disabled push-right"
          >
            <div class="label-img">
              <img src="assets/images/calendar-gray.svg" alt="expiration date" class="btn-icon-svg" />
              <span style="font-size: 12px;margin-left:3px">Export Expiration Date</span>
            </div>
          </button>
          <button
            *ngIf="hasExpPrefCol"
            class="btn reset-btn push-right"
            (click)="getExportExpiredData()"
          >
            <div class="label-img">
              <img src="assets/images/calendar.svg" alt="expiration date" class="btn-icon-svg" />
              Export Expiration Date
            </div>
          </button>
        </div>
      </div>
      <div class="div-head">
        <div class="title-legend">
          <div class="div-title">
            Source Cross Reference - {{ rTotalItems }}
            {{ rTotalItems > 1 ? "Results" : "Result" }}
          </div>
          <div class="legends" *ngIf="isDeaExpiredExist">
            <div class="legend">
              <div class="legend-box"></div>
              <label for="dea_expired" class="legend-lbl">{{
                constants.RESULT_PROFILE.DEA
              }}</label>
            </div>
          </div>
        </div>

        <mat-paginator
          #sourcePaginator
          [length]="rTotalItems"
          [pageSize]="rPageSize"
          [pageSizeOptions]="[5, 10, 25, 100]"
          (page)="onPageChangeCR($event)"
        >
        </mat-paginator>
      </div>
      <div class="div-source card-custom">
        <table
          mat-table
          [dataSource]="sourceCrossReferencesMp"
          matSort
          #sortCR="matSort"
          matSortDisableClear
          class="mat-elevation-z8 mat-table-sticky"
        >
          <ng-template ngFor let-col [ngForOf]="sourceDisplayedColumns">
            <ng-container [ngSwitch]="col">
              <ng-container [matColumnDef]="col" *ngSwitchCase="'rcm_id'">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  class="sticky-column"
                  [mat-sort-header]="col"
                >
                  {{ getDisplayColName("cross reference", col) }}
                </th>
                <td mat-cell *matCellDef="let element" class="sticky-column">
                  {{ element[col] }}
                </td>
              </ng-container>
              <ng-container [matColumnDef]="col" *ngSwitchCase="'source'">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  class="sticky-column"
                  [mat-sort-header]="col"
                >
                  {{ getDisplayColName("cross reference", col) }}
                </th>
                <td mat-cell *matCellDef="let element" class="sticky-column">
                  {{ element[col] }}
                </td>
              </ng-container>
              <ng-container [matColumnDef]="col" *ngSwitchCase="'source_id'">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  class="sticky-column"
                  [mat-sort-header]="col"
                >
                  {{ getDisplayColName("cross reference", col) }}
                </th>
                <td mat-cell *matCellDef="let element" class="sticky-column">
                  {{ element[col] }}
                </td>
              </ng-container>
              <ng-container
                [matColumnDef]="col"
                *ngSwitchCase="'address_line_1'"
              >
                <th mat-header-cell *matHeaderCellDef [mat-sort-header]="col">
                  {{
                    getDisplayColName(
                      "cross
                                    reference",
                      col
                    )
                  }}
                </th>
                <td mat-cell *matCellDef="let element" class="cr-col-name">
                  <a
                    href="javascript:void(0)"
                    class="clickable-cell"
                    (click)="getStandardAddress(element)"
                    >{{ element[col] }}</a
                  >
                </td>
              </ng-container>
              <ng-container [matColumnDef]="col" *ngSwitchCase="'dea_num'">
                <th mat-header-cell *matHeaderCellDef [mat-sort-header]="col">
                  {{
                    getDisplayColName(
                      "cross
                                    reference",
                      col
                    )
                  }}
                </th>
                <td mat-cell *matCellDef="let element">
                  <a
                    href="javascript:void(0)"
                    class="clickable-cell"
                    (click)="getExpireDate('DEA', element)"
                    >{{ element[col] }}</a
                  >
                </td>
              </ng-container>
              <ng-container [matColumnDef]="col" *ngSwitchCase="'sln'">
                <th mat-header-cell *matHeaderCellDef [mat-sort-header]="col">
                  {{
                    getDisplayColName(
                      "cross
                                    reference",
                      col
                    )
                  }}
                </th>
                <td mat-cell *matCellDef="let element">
                  <a
                    href="javascript:void(0)"
                    class="clickable-cell"
                    (click)="getExpireDate('SLN', element)"
                    >{{ element[col] }}</a
                  >
                </td>
              </ng-container>
              <ng-container [matColumnDef]="col" *ngSwitchCase="'tddd_oh'">
                <th mat-header-cell *matHeaderCellDef [mat-sort-header]="col">
                  {{
                    getDisplayColName(
                      "cross
                                    reference",
                      col
                    )
                  }}
                </th>
                <td mat-cell *matCellDef="let element">
                  <a
                    href="javascript:void(0)"
                    class="clickable-cell"
                    (click)="getExpireDate('TDDD', element)"
                    >{{ element[col] }}</a
                  >
                </td>
              </ng-container>
              <ng-container [matColumnDef]="col" *ngSwitchCase="'hcce'">
                <th mat-header-cell *matHeaderCellDef [mat-sort-header]="col">
                  {{
                    getDisplayColName(
                      "cross
                                    reference",
                      col
                    )
                  }}
                </th>
                <td mat-cell *matCellDef="let element">
                  <a
                    href="javascript:void(0)"
                    class="clickable-cell"
                    (click)="getExpireDate('HCCE', element)"
                    >{{ element[col] }}</a
                  >
                </td>
              </ng-container>
              <ng-container *ngSwitchDefault>
                <ng-container [matColumnDef]="col">
                  <th mat-header-cell *matHeaderCellDef [mat-sort-header]="col">
                    {{ getDisplayColName("cross reference", col) }}
                  </th>
                  <td mat-cell *matCellDef="let element" class="cr-col-name">
                    {{ element[col] }}
                  </td>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-template>
          <tr
            mat-header-row
            *matHeaderRowDef="sourceDisplayedColumns"
            class="sticky-header-row"
          ></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: sourceDisplayedColumns"
            [ngClass]="{
              dea_expired: row.source_exp_flag?.toLowerCase() === 'y'
            }"
          ></tr>
          <!-- No Data Row -->
          <tr class="mat-row" *matNoDataRow>
            <td
              class="mat-cell no-data-available"
              [attr.colspan]="sourceDisplayedColumns.length"
            >
              No data available
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="card-wrap">
      <div class="btn-reset">
       &nbsp;
        <div class="btns-right">
          
          <button
            class="btn reset-btn"
            (click)="showColumnSetting('golden profile')"
            aria-label="Golden Profile Column Settings"
          >
            <img src="assets/images/columnthing.svg" alt="column thing" class="btn-icon-svg" />
             {{ constants.RESULT_PROFILE.COLUMN_SETTINGS }}
          </button>
          <button
            class="btn reset-btn push-right"
            (click)="exportData()"
            aria-label="Export Golden Profile Data"
          >
            <div class="label-img">
              <!-- <img
                src="assets/images/share-forward-fill.png"
                class="export-icon"
                alt=""
              /> -->
              <i class="bi bi-download icon fs-5 btn-icon"></i>
              Export
            </div>
          </button>
        <span
  class="tooltip-wrapper"
  [class.show-tooltip]="!selectedGoldenProfile"
  [attr.data-tooltip]="
    !selectedGoldenProfile
      ? 'Select an account from below grid to move to affiliations page'
      : null
  "
>
  <button
    type="button"
    (click)="openAffiliationView()"
    class="btn reset-btn push-right"
    [disabled]="!selectedGoldenProfile"
  >
    <div class="label-img">
      <i class="bi bi-slack"></i>
      Affiliation View
    </div>
  </button>
</span>
        </div>
      </div>
      <div class="div-head">
        <div class="div-title" id="sanofi-profile-title">
          {{ constants.RESULT_PROFILE.SANOFI_PROFILE }} - {{ totalItems }}
          {{ totalItems > 1 ? "Results" : "Result" }}
        </div>
        <mat-paginator
          #profilePaginator
          [length]="totalItems"
          [pageSize]="pageSize"
          [pageSizeOptions]="[5, 10, 25, 100]"
          (page)="onPageChange($event)"
        >
        </mat-paginator>
      </div>
      <div class="div-profiles card-custom">
        <table
          mat-table
          matSort
          #sortGP="matSort"
          [dataSource]="goldenProfilesMp"
          matSortDisableClear
          class="mat-elevation-z8 profiles-table sticky-header-table"
          aria-labelledby="sanofi-profile-title"
        >
          <caption class="visually-hidden">
            Sanofi Golden Profile Table
          </caption>
          <ng-template ngFor let-col [ngForOf]="displayedColumns">
            <ng-container [matColumnDef]="col">
              <th
                mat-header-cell
                *matHeaderCellDef
                class="sticky-header css_th_{{ col }}"
                [mat-sort-header]="col"
                scope="col"
              >
                {{ getDisplayColName("golden profile", col) }}
              </th>
              <td mat-cell *matCellDef="let element" class="css_td_{{ col }}">
                {{ element[col] }}
              </td>
            </ng-container>
          </ng-template>

          <tr
            mat-header-row
            *matHeaderRowDef="displayedColumns"
            class="sticky-header-row"
          ></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns"
            (click)="selectProfile(row)"
            [ngClass]="{
              'ptrow-active':
                selectedGoldenProfile &&
                selectedGoldenProfile.rcm_id === row.rcm_id
            }"
            aria-label="Select Golden Profile Row"
            tabindex="0"
          ></tr>
          <!-- No Data Row -->
          <tr class="mat-row" *matNoDataRow>
            <td
              class="mat-cell no-data-available"
              [attr.colspan]="displayedColumns.length"
            >
              No data available
            </td>
          </tr>
        </table>
      </div>

    
    </div>
  </div>
</main>

<ng-template #modalContent let-modal>
  <div class="modal-body">
    <div class="card-custom">
      <table
        mat-table
        [dataSource]="standardData"
        class="mat-elevation-z8 profiles-table"
      >
        <ng-container matColumnDef="source_id">
          <th mat-header-cell *matHeaderCellDef class="sticky-header">
            {{ constants.RESULT_PROFILE.SOURCE_ID }}
          </th>
          <td mat-cell *matCellDef="let element">{{ element.source_id }}</td>
        </ng-container>

        <ng-container matColumnDef="address_line_1">
          <th mat-header-cell *matHeaderCellDef class="sticky-header">
            {{ constants.RESULT_PROFILE.SOURCE_ADDRESS }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.address_line_1 }}
          </td>
        </ng-container>

        <ng-container matColumnDef="std_address_line_1">
          <th mat-header-cell *matHeaderCellDef class="sticky-header">
            {{ constants.RESULT_PROFILE.NORMALIZED_ADDRESS }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.std_address_line_1 }}
          </td>
        </ng-container>

        <!-- <ng-container matColumnDef="std_address_line_2">
                    <th mat-header-cell *matHeaderCellDef class="sticky-header">Standard Address Line 2</th>
                    <td mat-cell *matCellDef="let element">{{element.std_address_line_2}}</td>
                </ng-container> -->
        <tr
          mat-header-row
          *matHeaderRowDef="sADisplayedColumns"
          class="sticky-header-row"
        ></tr>
        <tr mat-row *matRowDef="let row; columns: sADisplayedColumns"></tr>
      </table>
    </div>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-sm btn-primary"
      (click)="modal.close('Close click')"
    >
      {{ constants.CLOSE }}
    </button>
  </div>
</ng-template>
